import api from "./api"

export interface LoginCredentials {
  email: string
  password: string
}

export interface AdminUser {
  id: number
  name: string
  email: string
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<AdminUser> {
    const { data } = await api.post("/admin/login", credentials)
    if (data.token) {
      localStorage.setItem("admin_token", data.token)
    }
    if (data.user) {
      localStorage.setItem("admin_user", JSON.stringify(data.user))
    }
    return data.user
  },

  async logout(): Promise<void> {
    try {
      await api.post("/admin/logout")
    } finally {
      localStorage.removeItem("admin_token")
      localStorage.removeItem("admin_user")
    }
  },

  async me(): Promise<AdminUser> {
    const { data } = await api.get("/admin/me")
    if (data.user) {
      localStorage.setItem("admin_user", JSON.stringify(data.user))
    }
    return data.user
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem("admin_token")
  },

  getUser(): AdminUser | null {
    const raw = localStorage.getItem("admin_user")
    if (!raw) return null
    try {
      return JSON.parse(raw) as AdminUser
    } catch {
      return null
    }
  },
}